(()=>{
  function initializeStudio(){
    const header=document.querySelector('.zesti-chrome .site-header');
    if(header&&!header.dataset.studioReady){
      header.dataset.studioReady='true';
      const button=header.querySelector('.menu-toggle'),nav=header.querySelector('#main-nav');
      if(button&&nav){
        const close=()=>{button.setAttribute('aria-expanded','false');button.setAttribute('aria-label','Open menu');nav.classList.remove('is-open');};
        button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));button.setAttribute('aria-label',open?'Close menu':'Open menu');nav.classList.toggle('is-open',open);if(open)nav.querySelector('a')?.focus();});
        nav.addEventListener('click',event=>{if(event.target.closest('a'))close();});
        document.addEventListener('keydown',event=>{if(event.key==='Escape'&&button.getAttribute('aria-expanded')==='true'){close();button.focus();}});
        document.addEventListener('click',event=>{if(!header.contains(event.target))close();});
        matchMedia('(min-width: 801px)').addEventListener('change',event=>{if(event.matches)close();});
      }
    }
    const root=document.querySelector('.zesti-home');
    if(!root||root.dataset.studioReady)return;
    root.dataset.studioReady='true';
    const dialog=root.querySelector('#grow-demo'),player=root.querySelector('#demo-player');
    if(!dialog||!player)return;
    let trigger;
    root.querySelectorAll('[data-open-demo]').forEach(button=>button.addEventListener('click',()=>{
      trigger=button;dialog.querySelector('#demo-title').textContent='From setup to greens.';
      dialog.querySelector('.dialog-heading .eyebrow').textContent='22-SECOND GROWING FILM';
      dialog.querySelector('.demo-context').textContent='Visual description: the bamboo frame holds a white water reservoir and raised growing insert. A mat is placed on the insert, water is added below it, and seeds are spread across the mat. The covered setup gives way to growing shoots and a tray of leafy microgreens ready to snip. Growth is condensed into this silent 22-second film; the supplied guide and seed packet give actual quantities, timing and care.';
      const source=dialog.querySelector('a');source.href=dialog.dataset.filmSrc;source.textContent='Open the growing film ↗';
      const film=document.createElement('video');film.src=dialog.dataset.filmSrc;film.poster=dialog.dataset.filmPoster;film.controls=true;film.playsInline=true;film.muted=true;film.autoplay=true;film.setAttribute('aria-label','Silent ZestiGreens bamboo kit film: setup, watering, seeds and growing greens');
      player.replaceChildren(film);dialog.showModal();
    }));
    dialog.querySelector('.dialog-close').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{let bounds=dialog.getBoundingClientRect();if(event.target===dialog&&(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom))dialog.close();});
    dialog.addEventListener('close',()=>{player.querySelector('video')?.pause();player.replaceChildren();trigger?.focus({preventScroll:true});});
  }
  initializeStudio();document.addEventListener('shopify:section:load',initializeStudio);
})();

/* 2026-10-07: mirror the cart drawer's open state onto <body> so the chat-launcher rule in zesti-studio.css
   works in browsers without :has(). The drawer toggles its own `open` attribute (theme.js Drawer). The body
   class is recomputed from the live DOM on every change, so a removed or replaced drawer clears it too. */
(function () {
  var watched = null;
  var drawerObserver = null;
  function syncDrawerState() {
    var open = !!document.querySelector('cart-drawer[open]');
    document.body.classList.toggle('zesti-cart-drawer-open', open);
  }
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer !== watched) {
      if (drawerObserver) drawerObserver.disconnect();
      drawerObserver = null;
      watched = drawer;
      if (drawer) {
        drawerObserver = new MutationObserver(syncDrawerState);
        drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['open'] });
      }
    }
    syncDrawerState();
  }
  function start() {
    watchDrawer();
    // Re-arm when the drawer's section is replaced or removed (theme editor, section re-render).
    new MutationObserver(watchDrawer).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', watchDrawer);
    document.addEventListener('shopify:section:unload', watchDrawer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Push 17 (Tom, 2026-10-07): the sticky add-to-cart bar is its own <form>, so it never received the purchase option the customer chose in
   the main product form. The subscription app writes the chosen plan into a hidden selling_plan field that belongs to the main form only,
   and the theme's sticky-atc-bar.js syncs the variant but not the plan or the quantity. Result: with "Subscribe & Save" selected, the main
   button posted selling_plan=<id> but the sticky button posted no selling_plan (a one-time line).
   Fix, no markup change: (1) when the sticky form submits — capture phase, so before the theme's ProductForm builds FormData(this) — copy the
   main form's current selling_plan into a hidden field in the sticky form, or remove it when one-time purchase is selected; copy the main
   form's quantity too. (2) Mirror quantity changes between the two forms so both controls always show the same number. */
(function () {
  function mainForm() {
    var btn = document.querySelector('.main-product-form button[name="add"]');
    return btn ? btn.form : null;
  }
  function stickyForm() {
    return document.getElementById('product-form-sticky-atc-bar');
  }
  function field(form, name) {
    if (!form) return null;
    var f = form.elements.namedItem(name);
    if (f && !f.tagName && typeof f.length === 'number') f = f[0];
    return f || null;
  }
  function copyValue(from, to) {
    if (from && to && from.value !== to.value) to.value = from.value;
  }
  document.addEventListener('submit', function (event) {
    var sticky = stickyForm();
    if (!sticky || event.target !== sticky) return;
    var main = mainForm();
    var plan = main ? new FormData(main).get('selling_plan') || '' : '';
    var planInput = sticky.querySelector('input[name="selling_plan"][data-zesti-plan-sync]');
    if (plan) {
      if (!planInput) {
        planInput = document.createElement('input');
        planInput.type = 'hidden';
        planInput.name = 'selling_plan';
        planInput.setAttribute('data-zesti-plan-sync', '');
        sticky.appendChild(planInput);
      }
      planInput.value = plan;
    } else if (planInput) {
      planInput.remove();
    }
    copyValue(field(main, 'quantity'), field(sticky, 'quantity'));
  }, true);
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.name !== 'quantity') return;
    var sq = field(stickyForm(), 'quantity');
    var mq = field(mainForm(), 'quantity');
    if (target === mq) copyValue(mq, sq);
    else if (target === sq) copyValue(sq, mq);
  });
})();

/* Push 19 (Tom brief P1, chat placement), revised in pushes 21–22 (Tom P2 U1 + chat second opinion): keep the HeiChat launcher but do
   not show the app's automatic "Need help?" callout on product and contact pages (all widths) or on any page at phone and tablet widths (push 24: up to 1023px), where it
   covered titles, search results and policy text. Visual only: a theme-owned <style> is added to the launcher's shadow root, so the
   app's own inline styles/state are never read or written (push 22: no restore path can undo the app's hiding). The app's close
   control is not clicked; the launcher stays available. Route match is anchored (optional locale prefix); a light 2 s check re-adds
   the style if the app replaces its launcher host or shadow root. */
(function () {
  var routeMatch = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:products\/|pages\/contact(?:-us)?(?:\/|$))/i.test(location.pathname);
  /* Push 56: the automatic callout covered product cards, guide cards and body text on desktop as well, so it stays
     closed at every width. The launcher button itself is unchanged and opens the chat as before. */
  var brandLogo = document.querySelector('.site-header .brand img');
  var logoUrl = brandLogo && brandLogo.src;
  var css = 'heichat-callout-shell{display:none!important}' + (logoUrl ? '.launcher-host .custom-image{content:url("'+logoUrl+'");object-fit:contain!important;background:#fbfaf4!important;padding:7px!important;box-sizing:border-box!important}' : '');
  function check() {
    var shell = document.querySelector('heichat-launcher-shell');
    var root = shell && shell.shadowRoot;
    if (!root || root.querySelector('style[data-zesti-callout]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-zesti-callout', '');
    style.textContent = css;
    root.appendChild(style);
  }
  check();
  setInterval(check, 2000);
})();

/* Push 26 (Tom P2 fixed widgets), widened to ≤1279px in push 28: at narrower widths the HeiChat launcher sat over CTAs, product copy and policy text. On those widths the
   launcher is shown when the footer is in view (its bottom-right corner is empty there) or once the visitor has touched it; the small
   social launcher is hidden by CSS. Desktop unchanged. Visual only; the app is never clicked, configured or read. */
(function () {
  var footer = document.querySelector('.site-footer');
  if (!footer || !('IntersectionObserver' in window)) { document.body.classList.add('zesti-chat-dock'); return; }
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { document.body.classList.toggle('zesti-chat-dock', e.isIntersecting); });
  }, { rootMargin: '0px 0px -40% 0px' }).observe(footer);
  document.addEventListener('pointerdown', function (e) {
    if (e.target && e.target.closest && e.target.closest('heichat-launcher-shell')) document.body.classList.add('zesti-chat-engaged');
  }, true);
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.closest && e.target.closest('heichat-launcher-shell')) document.body.classList.add('zesti-chat-engaged');
  });
})();

/* Push 26, revised push 28: sign-up pages with a provider embed that never renders get a short, honest fallback (main-page.liquid).
   The notice tracks the content: shown while no sign-up form (a form with an email field) is present, hidden again if the provider
   mounts one later. Unrelated iframes/forms do not count. Checked for 60 s after load (push 35: shown after 10 s, or 20 s while the
   provider container is still rendering). */
(function () {
  var box = document.querySelector('[data-zesti-signup-fallback]');
  if (!box) return;
  var content = box.parentElement;
  function hasSignup() { return !!content.querySelector('form input[type="email"], form input[name*="email" i]'); }
  // Push 35: an embedded Omnisend container that has started rendering counts as loading, not missing.
  function providerMounting() { var c = content.querySelector('[id^="omnisend-embedded"]'); return !!(c && c.childElementCount); }
  var started = Date.now();
  var t = setInterval(function () {
    var elapsed = Date.now() - started;
    if (hasSignup()) { box.hidden = true; } else if (elapsed >= 10000 && !providerMounting()) { box.hidden = false; } else if (elapsed >= 20000) { box.hidden = false; }
    if (elapsed > 60000) clearInterval(t);
  }, 1000);
})();

/* Push 28: embedded app forms on legacy pages carry two links without a scheme ("amazon.com/…", "zestigreens.com"), which the
   browser resolves as store paths and 404s. Add https:// only — the stated destination is unchanged. */
(function () {
  function repair(root) {
    (root || document).querySelectorAll('.studio-legacy a[href]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (/^(www\.)?[a-z0-9-]+(\.[a-z0-9-]+)*\.(com|net|org|co|io|us)(\/[^\s]*)?$/i.test(h)) a.setAttribute('href', 'https://' + h);
    });
  }
  var legacy = document.querySelector('.studio-legacy');
  if (!legacy) return;
  repair();
  new MutationObserver(function () { repair(); }).observe(legacy, { childList: true, subtree: true });
})();

/* Push 55: Choose How You Grow — the microgreens card plays a muted, looping timelapse while it is on screen.
   Playback starts only when the card is visible and the page is shown; reduced motion keeps the poster until the
   shopper presses Play. The play/pause button sits outside the card link so the link still navigates. */
(function () {
  document.querySelectorAll('[data-method-video]').forEach(function (video) {
  var key = video.getAttribute('data-method-video');
  var toggle = document.querySelector('[data-method-video-toggle="' + key + '"]');
  var name = key === 'sprouts' ? 'sprouting' : 'microgreens';
  if (!video || !toggle) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var wanted = !reduce.matches, onScreen = false;
  video.muted = true;
  function sync() {
    var playing = !video.paused;
    toggle.setAttribute('aria-label', (playing ? 'Pause' : 'Play') + ' ' + name + ' timelapse');
    toggle.dataset.state = playing ? 'playing' : 'paused';
  }
  function update() {
    if (wanted && onScreen && !document.hidden) {
      video.autoplay = true;
      var p = video.play();
      if (p && p.catch) p.catch(function (e) { if (e && e.name === 'NotAllowedError') wanted = false; sync(); });
    } else if (!video.paused) {
      video.pause();
    }
  }
  video.addEventListener('play', sync);
  video.addEventListener('pause', sync);
  toggle.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    wanted = video.paused;
    if (wanted) onScreen = true;
    update();
  });
  document.addEventListener('visibilitychange', update);
  reduce.addEventListener && reduce.addEventListener('change', function () { if (reduce.matches) { wanted = false; update(); } });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { onScreen = entries[0].isIntersecting; update(); }, { threshold: 0.25 }).observe(video);
  } else {
    onScreen = true;
  }
  toggle.hidden = false;
  sync();
  update();
  });
})();


/* Push 57 (visual system): small finishing touches for app-rendered blocks. Text and behaviour of the apps are unchanged
   except where a label is replaced by a clearer one. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var isProduct = document.querySelector('.zesti-native--product');
    function tidy() {
      if (isProduct) {
        // one recommendation band: hidden when it would show fewer than two products
        var rp = document.querySelector('[id$="__related-products"]');
        if (rp) {
          var n = rp.querySelectorAll('.product-card').length;
          var loaded = rp.querySelector('product-recommendations') && rp.querySelector('.products-list, .swiper-wrapper, .f-grid');
          if (loaded) rp.classList.toggle('zv-hide', n < 2);
        }
        // the product's own reviews are labelled as such (the strip above is brand-wide)
        // recipe filter pills and the "All Posts" pill in sentence case
        var purchase = document.querySelector('.purchase-option-title-esa');
        if (purchase && purchase.textContent.trim() === 'Purchase Option') purchase.textContent = 'Purchase option';
        var t = document.querySelector('.jdgm-rev-widg__title');
        if (t && t.textContent.trim() !== 'Reviews of this product') t.textContent = 'Reviews of this product';
      }
      document.querySelectorAll('.zesti-native--blog a').forEach(function (a) {
        if (a.textContent.trim() === 'All Posts') a.textContent = 'All posts';
      });
      // warranty registration: visible field labels and a plain button label
      var om = document.querySelector('.studio-legacy [id^="omnisend-embedded"]');
      if (om) {
        om.querySelectorAll('input[placeholder]').forEach(function (input) {
          if (input.type === 'hidden' || input.dataset.zvLabelled) return;
          var text = /mail/i.test(input.placeholder + input.name + input.type) ? 'Email' : (/first/i.test(input.placeholder) ? 'First name' : input.placeholder);
          var label = document.createElement('label'); label.className = 'zv-om-label'; label.textContent = text;
          if (!input.id) input.id = 'zv-om-' + Math.random().toString(36).slice(2, 8);
          label.setAttribute('for', input.id); input.parentNode.insertBefore(label, input); input.dataset.zvLabelled = '1';
        });
        om.querySelectorAll('button').forEach(function (b) { if (/yes,?\s*please/i.test(b.textContent)) b.textContent = 'Register my kit'; });
      }
    }
    tidy();
    var runs = 0, timer = setInterval(function () { tidy(); if (++runs > 20) clearInterval(timer); }, 700);
  });
})();


/* Push 59: "All products" opens in best-selling order unless the shopper has chosen a sort.
   Push 94: the Bamboo preview is an alternate view of this address and lists no products, so it is left as it is. */
(function () {
  try {
    if (/\/collections\/all\/?$/.test(location.pathname)) {
      var q = new URLSearchParams(location.search);
      if (!q.has('sort_by') && q.get('view') !== 'bamboo-jar-sprouter') { q.set('sort_by', 'best-selling'); location.replace(location.pathname + '?' + q.toString() + location.hash); }
    }
  } catch (e) {}
})();

(function () {
  function syncPack(group) {
    var form = group.closest('form');
    var quantity = form && form.querySelector('input[name="quantity"]');
    if (!quantity) return;
    var count = Number(quantity.value) || 1;
    var chosen = null;
    group.querySelectorAll('input[name="zv_kit_pack"]').forEach(function (radio) {
      radio.checked = Number(radio.value) === count;
      if (radio.checked) chosen = radio;
    });
    var price = form.querySelector('.zv-atc-price');
    if (!price) return;
    var total = Number(group.dataset.unitPrice) * count - (count >= 2 ? Number(group.dataset.saving) : 0);
    var formatted = chosen ? chosen.dataset.total : new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: group.dataset.currency}).format(total / 100);
    price.textContent = ' — ' + formatted;
  }
  function initializePacks() {
    document.querySelectorAll('.zv-kit-choice').forEach(function (group) {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      group.addEventListener('change', function (event) {
        if (event.target.name !== 'zv_kit_pack') return;
        var quantity = group.closest('form').querySelector('input[name="quantity"]');
        quantity.value = event.target.value;
        quantity.dispatchEvent(new Event('change', {bubbles: true}));
        syncPack(group);
      });
      syncPack(group);
    });
  }
  document.addEventListener('change', function (event) {
    if (event.target.name !== 'quantity') return;
    requestAnimationFrame(function () {document.querySelectorAll('.zv-kit-choice').forEach(syncPack);});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializePacks); else initializePacks();
  document.addEventListener('shopify:section:load', initializePacks);
})();
